import { metricsScales } from '@linearb/linjs-common';

const getRangeText = ({ minValue, maxValue, unit }) => {
  const unitStr = unit === '%' ? unit : ` ${unit}`;
  if (minValue && maxValue) {
    return `${minValue} - ${maxValue}${unitStr}`;
  } else if (minValue) {
    return `${minValue}${unitStr} or more`;
  } else if (maxValue) {
    return `Up to ${maxValue}${unitStr}`;
  }
};

export const getRange = ({
  minValue,
  maxValue,
  unit,
  scale,
  benchmarkRangeText
}) => {
  if (benchmarkRangeText) {
    return benchmarkRangeText;
  }

  if (scale === metricsScales.TIME) {
    minValue = Math.floor(minValue / 60);
    maxValue = Math.floor(maxValue / 60);
    if (minValue % 24 === 0 && maxValue % 24 === 0) {
      minValue = minValue / 24;
      maxValue = maxValue / 24;
      unit = 'days';
    }
  }

  return getRangeText({ minValue, maxValue, unit });
};
